import React, { ChangeEvent } from 'react';
import searchIcon from '../../assets/img/search-icon.svg';
import { useSearchUserContext } from './SearchUserContext';

export const SearchUser: React.FC = () => {
  const { setSearch, searchString } = useSearchUserContext();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    setSearch(event.target.value.toLowerCase());

  return (
    <div className='users__search'>
      <input
        className='f5'
        value={searchString}
        type='text'
        onChange={handleChange}
        placeholder='Search user'
      />
      {!searchString && <img src={searchIcon} alt='search' className='users__search-icon' />}
    </div>
  );
};
